<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for="mailable">Mailable</label>
                        <select id="mailable" v-model="selectedMailableType" class="form-control" :size="Math.min(20, mailableTypes.length)" @change="loadMailableType">
                            <option v-for="value of mailableTypes" :value="value">{{value.replace(/([A-Z])/g, ' $1').trim()}}</option>
                        </select>
                    </div>
                    <button class="btn btn-secondary" @click="loadMailableType" :disabled="!selectedMailableType">
                        {{ selectedIsLoaded ? 'Reload' : 'Load' }}
                    </button>
                    <div class="mt-2">
                        <a v-if="mailable" :href="showRoute" target="_blank"><em class="small">{{showRoute}}</em></a>
                    </div>
                </div>
                <div class="col-lg-9">
                    <div class="form-control p-0" style="height: 50rem;">
                        <div v-if="mailable" class="h-100">
                            <iframe ref="iframe" :src="showRoute" class="w-100 h-100" style="border: none;"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "PreviewMail",
    props: {
      route: String
    },
    data() {
      return {
        mailableTypes: [],
        selectedMailableType: null,
        mailable: null,
      }
    },
    mounted() {
      this.fetchAvailableMailTypes();
    },
    computed: {
      showRoute() {
        return `${this.route}/${this.mailable}`;
      },
      selectedIsLoaded() {
        return this.selectedMailableType && this.mailable === this.selectedMailableType;
      }
    },
    methods: {
      loadMailableType() {
        if (this.selectedIsLoaded) {
          this.$refs.iframe.contentWindow.location.reload();
          return;
        }

        this.mailable = this.selectedMailableType;
      },
      fetchAvailableMailTypes() {
        axios.get(this.route).then((response) => {
          this.mailableTypes = response.data;
        }).catch((error) => {

        });
      }
    }
  }
</script>

<style scoped>
    #mailable {
        padding: 0;
    }
    #mailable > option {
        padding: .25rem .5rem;
    }
</style>